import { AlertCircle } from 'lucide-react'

interface CompleteProfileBannerProps {
  percentage: number
  message?: string
}

/**
 * Banner shown at top of profile page when profile is incomplete
 */
export function CompleteProfileBanner({
  percentage,
  message = "Your profile is incomplete. Add your experience and portfolio to increase your match rate by 3x and start receiving client opportunities.",
}: CompleteProfileBannerProps) {
  return (
    <div
      className="rounded-[40px] border-[3px] border-[rgba(245,158,11,0.60)] p-8 mb-6"
      style={{
        background: 'linear-gradient(99.87deg, rgba(245, 158, 11, 0.1) 0%, rgba(249, 115, 22, 0.1) 100%)',
      }}
    >
      <div className="flex flex-col items-center text-center">
        {/* Icon Circle */}
        <div className="w-20 h-20 rounded-full bg-white flex items-center justify-center mb-4">
          <AlertCircle className="w-8 h-8 text-amber-500" />
        </div>

        {/* Title */}
        <h2 className="text-[32px] font-normal text-slate-900 tracking-tight mb-2">
          Complete your profile to start getting matched
        </h2>

        {/* Description */}
        <p className="text-lg text-slate-500 max-w-[800px]">
          Your profile is {percentage}% complete. {message}
        </p>
      </div>
    </div>
  )
}
